import { Dispatch } from "redux";
import apiFetch from "../token-guard/apiFetch";

export default async function fetchAgencyProfile(
  dispatch: Dispatch<any>
) {
  try {
    const data = await apiFetch(
      "/api/agency/profile", 
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    );

    return data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch agency profile");
  }
}
